import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import AdCard from './AdCard';
import { Skeleton } from '../components/ui/skeleton';

const AdGrid = ({ ads, loading, onAdClick, onToggleFavorite, onDelete }) => {
  if (loading) {
    return (
      <div className="masonry-grid">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="masonry-item">
            <div className="bg-zinc-900/50 rounded-xl overflow-hidden border border-white/5">
              <Skeleton className="w-full aspect-video" />
              <div className="p-4 space-y-3">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-3 w-full" />
                <div className="flex gap-2">
                  <Skeleton className="h-5 w-16 rounded-full" />
                  <Skeleton className="h-5 w-16 rounded-full" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (ads.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="flex flex-col items-center justify-center py-20"
      >
        <div className="w-24 h-24 rounded-full bg-zinc-800/50 flex items-center justify-center mb-6">
          <svg
            className="w-12 h-12 text-zinc-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
        <h3 className="text-xl font-semibold text-zinc-300 mb-2">No ads yet</h3>
        <p className="text-zinc-500 text-center max-w-md">
          Start by pasting an Instagram URL, dropping an image, or pasting a screenshot above.
        </p>
      </motion.div>
    );
  }

  return (
    <div className="masonry-grid" data-testid="ad-grid">
      <AnimatePresence mode="popLayout">
        {ads.map((ad, index) => (
          <motion.div
            key={ad.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
          >
            <AdCard
              ad={ad}
              onClick={onAdClick}
              onToggleFavorite={onToggleFavorite}
              onDelete={onDelete}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default AdGrid;
